import { useNavigate, useParams } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { User } from "@modules/users/types/user";
import { EditUserFormValues } from "@modules/users/validations/editUserSchama";
import { editUserService } from "./service";
import { UseEditUserMutationOptions } from "./types";

export function useEditUserMutation(
  options?: UseEditUserMutationOptions
) {
  const { id } = useParams();
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<User, ApiError, EditUserFormValues>({
    mutationKey: ["user", id],
    mutationFn: (data: EditUserFormValues) => editUserService(id as string, data),
    onSuccess: (user: User) => {
      open?.({
        type: "success",
        message: translate("v1/user_admin.success.edit"),
      });

      navigate(`/users/edit/${user.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
